import { normalizeManagerName } from './managerStats';

// The published late Week 3 issue captured Yahoo team labels as managers.
// Freeze this issue's verified team IDs so later team renames cannot alter its portraits.
const LATE_2026_WEEK_3_MANAGERS = Object.freeze({
  '1': 'Robby', '2': 'Bryan', '3': 'Kyle', '4': 'Josh', '5': 'Amir',
  '6': 'A.J.', '7': 'Kevin', '8': 'Anna', '9': 'Ryan', '10': 'Samuel',
});

export function presentPredictionTeam(team, issue) {
  const manager = normalizeManagerName(team.manager);
  const isAffectedIssue = issue?.season === 2026 && issue?.week === 3
    && issue?.editionType === 'late-2026-week-3';
  const correctedManager = isAffectedIssue && manager && manager === team.teamName
    ? LATE_2026_WEEK_3_MANAGERS[String(team.id)]
    : null;
  return {
    ...team,
    manager: correctedManager || manager,
  };
}

export function displayForecastHeadline(headline) {
  return String(headline || '').replace(/^\s*Bruins09\s+AI\s*:\s*/i, '');
}
